export default "__VITE_ASSET__Cf$rbWk7__"